import React from 'react';
import PropTypes from 'prop-types';
import Star from '../StarIcon';
import styles from './styles.module.scss';

const Rating = ({ rating = 0 }) => (
    <div className={styles.rating}>
        {Array.from({ length: 5 }, (_, i) => (
            <Star key={i} filled={i < rating} />
        ))}
    </div>
);


Rating.propTypes = {
    rating: PropTypes.number,
};

export default Rating;
